import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../constants/media';
import { IRichText } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import RichText from '../base/richText';
import RichTextTitle from '../base/richTextTitle';

const Root = styled.div`
	margin-top: 150px;
`;

const RichTextTitleStyled = styled(RichTextTitle)`
	${media.desktopSmall`
		text-align: center;
	`};
`;

const RichTextStyled = styled(RichText)`
	margin-top: 56px;
`;

interface Props {
	content: IRichText;
}

const DynamicRichText: FC<Props> = ({ content }) => {
	return (
		<Root>
			<ContentContainer>
				{!content.Values.HideTitle && <RichTextTitleStyled content={content.Values.Title} type="h3" />}
				<RichTextStyled content={content.Values.Content} />
			</ContentContainer>
		</Root>
	);
};

export default DynamicRichText;
